import React from 'react';
import './Label.scss';
export type labelView = 'mfg-block' | 'mfg-inline';
export interface Props {
  LabelClass?: any,
  LabelId?: any,
  children?: any,
  Labelfor?: any,
  labelView ?: labelView
}

const Label = ({
  LabelClass,
  LabelId,
  Labelfor,
  children,
  labelView = "mfg-inline"
}:Props) => {
  return (
    <label className={`${labelView}${LabelClass ? (' '+LabelClass) : ''}`} id={LabelId} htmlFor={Labelfor}>
      {children}
    </label>
  )
}

export default Label
